import { Laptop24Regular, Server24Regular } from "@fluentui/react-icons";
import React, { useCallback, useMemo } from "react";

import { Button } from "@fluentui/react-components";
import { IAppMenuFlyoutProps } from "./AppMenuFlyout.types";
import { M365PulseInfoRows } from "Shared/Components";
import { observer } from "mobx-react";
import { useAppSettings } from "Shared/Hooks";
import { useGlobalSetting } from "Store/GlobalSettingStore";
import { useHelpStyle } from "./AppMenuHelp.styles";
import { useNavigate } from "react-router";
import { useORPCQuery } from "Core/oRPC";
import { useQuery } from "@tanstack/react-query";

const AppMenuHelpBase = (props: IAppMenuFlyoutProps) => {
    const classes = useHelpStyle();
    const { m365appVersion } = useAppSettings();
    const { coreApi } = useORPCQuery();
    const { data } = useQuery(coreApi.getCurrentVersion.queryOptions());

    const settingStore = useGlobalSetting("dashboardApp");
    const { onDismiss } = props;
    const navigate = useNavigate();

    const frontEndVersion = useMemo(
        () => [
            {
                content: m365appVersion ?? "N/A",
                fieldName: "Frontend"
            }
        ],
        [m365appVersion]
    );

    const backEndVersion = useMemo(
        () => [
            {
                content: data ?? "N/A",
                fieldName: "Backend"
            }
        ],
        [data]
    );

    const showTour = useCallback(() => {
        onDismiss?.();
        if (settingStore.userSettingData.views.length === 0) {
            navigate("/Dashboard/AddView");
            settingStore.setDisplayNewUserDashboardTour(true);
        } else {
            navigate("/Dashboard");
            settingStore.setDisplayDashboardTour(true);
        }
    }, [navigate, onDismiss, settingStore]);

    return (
        <div className={classes.root}>
            <h3>M365 Pulse Build Version</h3>
            <div className={classes.versionContainer}>
                <Laptop24Regular className={classes.icon} />
                <M365PulseInfoRows items={frontEndVersion} vertical boldedFieldName />
            </div>
            <div className={classes.versionContainer}>
                <Server24Regular className={classes.icon} />
                <M365PulseInfoRows items={backEndVersion} vertical boldedFieldName />
            </div>
            <h3>Tour the new M365 Pulse</h3>
            <Button appearance="primary" onClick={showTour}>
                Tour M365 Pulse
            </Button>
        </div>
    );
};

export const AppMenuHelp = observer(AppMenuHelpBase);
